<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <router-link to="/liquidaciones/clientes" class="pull-right">Volver a la lista</router-link>
      </div>
      <div class="form smart-form">
        <div class="box-body">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="">Monto</label>
                <input type="number" class="form-control" v-model="importe">
              </div>
              <div class="form-group">
                <label for="">Tipo de pago</label>
                <select class="form-control" v-model="tipo">
                  <option value="Efectivo">Efectivo</option>
                  <option value="Cheque">Cheque</option>
                  <option value="Transferencia">Transferencia</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">Comprobante</label>
                <input type="text" class="form-control" v-model="comprobante">
              </div>
            </div>
            <div class="col-sm-8">
              <div class="form-group">
                <label for="">Movimientos</label>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Tipo</th>
                      <th>Comprobante</th>
                      <th class="text-right">Monto a cobrar</th>
                      <th class="text-right">Monto cobrado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="movimiento in movimientos">
                      <td>{{movimiento.fecha | formatFecha}}</td>
                      <td>{{movimiento.tipo}}</td>
                      <td>{{movimiento.comprobante}}</td>
                      <td class="text-right">
                        <span v-if="!movimiento.esPago">{{movimiento.importe | formatMoneda}}</span>
                      </td>
                      <td class="text-right">
                        <span v-if="movimiento.esPago">{{movimiento.importe | formatMoneda}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="pull-right">
                  <span class="label label-info">Saldo: {{saldo | formatMoneda}}</span>
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="form-group">
                <div class="text-center center-block">
                  <button class="btn btn-fill" @click.prevent="clickCobrar">Guardar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import moment from 'moment'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'

  export default {
    computed: {
      saldo () {
        const me = this
        let saldo = 0
        me.movimientos.forEach((movimiento) => {
          if (!movimiento.esPago) {
            saldo += movimiento.importe
          } else {
            saldo -= movimiento.importe
          }
        })
        return saldo
      }
    },
    data () {
      return {
        idLiquidacion: null,
        importe: 0,
        tipo: 'Efectivo',
        empresa: null,
        comprobante: '',
        movimientos: []
      }
    },
    filters: {
      formatFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      },
      formatMoneda (value) {
        return '$ ' + parseFloat(value).toFixed(2)
      }
    },
    created () {
      const me = this
      me.idLiquidacion = me.$route.params.id
    },
    methods: {
      clickCobrar () {
        const me = this
        swal({
          title: 'Crear cobro',
          text: '¿Desea crear el cobro?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, crear',
          cancelButtonText: 'No, cerrar esta ventana'
        }).then(() => {
          me.crearPago()
        }, (dismiss) => {
          return false
        })
      },
      clearForm () {
        const me = this
        me.importe = 0
        me.tipo = 'Efectivo'
        me.comprobante = ''
      },
      crearPago () {
        const me = this
        /*
        if (me.importe > me.saldo) {
          me.$emit('mostrar-notificacion', 'El importe es mayor al saldo', 'error')
          return false
        }
        */
        me.$emit('activar-modal')
        me.$http.post('/api/admin/liquidaciones/clientes/cobro', {
          origen: me.idLiquidacion,
          importe: parseFloat(me.importe),
          empresa: me.empresa,
          tipo: me.tipo,
          comprobante: me.comprobante
        }).then(({body}) => {
          me.getMovimientos()
          me.clearForm()
        }, (err) => {
          console.error(err)
        }).then(() => {
          me.$emit('cerrar-modal')
        })
      },
      getMovimientos () {
        const me = this
        me.$http.get('/api/admin/liquidaciones/movimientos', {
          params: {
            id: me.idLiquidacion
          }
        }).then(({body}) => {
          me.movimientos = body.movimientos
          if (me.movimientos.length > 0) {
            me.empresa = me.movimientos[0].empresa
          }
        }, (err) => {
          console.error(err)
        })
      }
    },
    mounted () {
      this.getMovimientos()
    }
  }
</script>



// WEBPACK FOOTER //
// FormCobroCliente.vue?c0d300f0